<template>
  <div class='sub'>
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
          <span @click.stop.prevent='backBtn' class='ico'>이전</span></a>
        </div>
        <div class='col col2'>
          <div class='schIntWrap'>
            <input
              v-model='keyword'
              type='text'
              class='input searhInput'
              @input="onCheckInput"
              :placeholder='placeholder'
              @keyup.enter='onEnter'
              enterkeyhint="search"
              autofocus/>
            <!-- <input v-model='keyword' type='text'
              :placeholder=""
              @keyup.enter='searchBtn()'/> -->
            <button v-show='showRmBtn' type='button' class='btn del' @click='onClickRmKeyword'/>
          </div>
        </div>
        <div class='col col3'>
          <a class='btnNavi sch'>
            <span @click='search' class='ico'>검색</span>
          </a>
        </div>
      </div>
    </header>
    <!-- 검색 페이지이기 때문에 아무것도 없는 화이트 페이지가 필요, 현재는 없기 때문에 조건 처리 -->
    <!-- 첫 진입 or API 응답 후-->
    <Loading v-if="loading || getLoading"/>
    <div v-else-if="searchType == 1 && hasSearched">
      <div v-if='list && list.length > 0' id='container'>
        <div class='schTopTxtWrap' v-if='$i18n.locale == "ko"'>
          <span class='point'>{{menuName}}</span>에 대한 {{list.length}}개의 매장이 있습니다.
        </div>
        <div class="mainStLst" v-for="(item,index) in list" :key="index" @click="reqQr(item.storeCode,item.menuExistFlag)">
          <div class="zone-left">
            <div class="comingSoon" v-if="item.menuExistFlag == 0">
              {{$t('openingSoon')}}
            </div>
            <div class="alive" v-else-if="item.aliveFlag">
              <p>{{$t('QR.closed')}}</p>
            </div>
            <!-- storeImageUrl 이미지url을 이용해서 표시 -->
            <img v-if="item.storeImageUrl" :src="item.storeImageUrl">
            <!-- 기본이미지 -->
            <img v-else :src="defaultImg">
          </div>

          <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-if 조건만 삭제 -->
          <div class="zone-right" v-if="!isTakeOutStoreIncluded(item.storeCode)">
            <!-- <img src="../assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType">
            <p class="marketName">{{item.marketName}}</p> -->
            <p class="name">{{item.storeName}}</p>
            <p class="text">
              <span class="sp1">{{$t('QR.deliveryFee')}}</span>
              <template v-if="item.from == 0 && item.to == 0">
                <span></span>
              </template>
              <template v-else-if="item.from == item.to">
                <span class="sp2" :class="{free:item.deliveryFeeFlag}">{{formatComma(item.from)}}원</span>
              </template>
              <template v-else>
                <span class="sp2" :class="{free:item.deliveryFeeFlag}">{{formatComma(item.from)}}원 ~ {{formatComma(item.to)}}원</span>
              </template>
              <span class="freeTag" v-if="item.from == 0 && item.to == 0">무료</span>
              <span class="freeTag" v-else-if="item.deliveryFeeFlag">무료</span>
              <span class="distance" v-if="item.distance !== undefined"><img src="../assets/img/ic_distance.png" alt="">{{item.distance + 'km'}}</span>
              <span class="package" v-if="item.usePickup">{{$t('QR.toGoOK')}}</span>
            </p>
          </div>

          <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-else 문 삭제 -->
          <div class="zone-right" v-else>
            <!-- <img src="../assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType">
            <p class="marketName" v-if="item.marketName">{{item.marketName}}</p> -->
            <p class="name">{{item.storeName}}</p>
            <p class="info-box">
              <span class="package">{{$t('QR.toGoOK')}}</span>&nbsp;
              <span class="no-delivery">배달불가</span>
            </p>
          </div>

        </div>
      </div>
      <div v-else class='noData full'>
        <div class='in'><p>{{$t('noResults')}}</p></div>
      </div>
    </div>
    <div v-else-if="searchType == 0 && hasSearched">
      <div v-if='menus && menus.length > 0' id='container'>
        <div class='schTopTxtWrap' v-if='this.$i18n.locale == "ko"'>
          <span class='point'>{{menuName}}</span>에 대한 {{menus.length}}개의 상품이 있습니다.
        </div>
        <div class='schTopTxtWrap' v-if='this.$i18n.locale == "en"'>
          <template v-if="menuName == '전체'">
            We've found {{menus.length}} menu(s) from the entire list.
          </template>
          <template v-else>
            We've found {{menus.length}} menu(s) from <span class='point'>{{menuName}}</span>.
          </template>
        </div>
        <div class='schTopTxtWrap' v-if='this.$i18n.locale == "cn"'>
          <template v-if="menuName == '전체'">
            We've found {{menus.length}} menu(s) from the entire list.
          </template>
          <template v-else>
            We've found {{menus.length}} menu(s) from <span class='point'>{{menuName}}</span>.
          </template>
        </div>
        <ul class='goodsList'>
          <li v-for='menu in menus' :key='menu.code'><MenuItem :menu='menu'/></li>
        </ul>
      </div>
      <div v-else class='noData full'>
        <div class='in'><p>{{$t('noResults')}}</p></div>
      </div>
    </div>
    <SingleBtnDialog
      v-if='showSingleBtnDialogFlag'
      :messageType='singleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :comingSoonFlag="singleBtnMsgType == 15 ? true : false"/>
  </div>
</template>
<script lang="js">
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import MenuItem from '@/components/Common/MenuItem.vue'
import Loading from '@/components/Common/Loading.vue'
import service from '@/backend/modnpay_app_api'
import { regexForEmoticaon } from '@/utils/CommonForVue'
import { SEARCH_PAGE_NAME } from '@/utils/EndPoint'
import { MSG_SEARCH_KEYWORD_LENGTH_LESS, NETWORK_ERROR_MESSAGE, DIS_ACCEPT_INPUT_DATA } from '@/utils/Message'

import { REQ_MENU_SEARCH } from '@/store/_actions/actionTypes'
import Vue from 'vue'
export default Vue.extend({
  name: SEARCH_PAGE_NAME,
  components: { MenuItem, SingleBtnDialog, Loading },
  data () {
    return {
      keyword: '', // 검색하고 싶은 keyword
      menuName: '', // 검색한 keyword
      menus: undefined, // 검색 결과
      list: [],
      isLastPage: '', // 마지막 페이지 여부
      page: 0, // 페이징 개수 (0부터 시작) (1회당 30개씩)
      showRmBtn: false, // 'X' 버튼 show Flag
      searchType: this.$route.query.searchType, // 0: 상품검색, 1: 매장검색
      showSingleBtnDialogFlag: false,
      singleBtnMsgType: 0,
      loading: true, // 첫 페이지 진입 여부
      hasSearched: false // 검색 여부 (검색 O - true, 검색 X - false)
    }
  },
  watch: {
    keyword () {
      if (this.keyword.length === 0) {
        this.menus = undefined
        this.showRmBtn = false
        /**
         * 검색어를 모두 삭제한 경우
         * 검색 여부를 false => 화이트 페이지 노출
         */
        this.hasSearched = false
      } else {
        this.showRmBtn = true
      }
    }
  },
  computed: {
    placeholder () {
      return this.searchType
        ? this.$i18n.locale == 'ko'
          ? '매장명 검색'
          : this.$i18n.locale == 'en'
            ? 'Store name search'
            : '店铺名称搜索'
        : this.$t('searchMenu')
    },
    defaultImg () { return require('../assets/img/list_img_empty.png') },
    getLoading () {
      return this.$store.getters.loading
    }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    setTimeout(() => {
      this.loading = false
    }, 200)
  },
  methods: {
    onEnter (e) {
      e.target.blur() // 모바일 키보드 내리기
      this.search()
    },
    backBtn () {
      history.back()
    },
    onClickRmKeyword () {
      this.keyword = ''
      this.list = []
    }, // 'X' 버튼 클릭
    onCheckInput () { // 검색 keyword 유효성 검사
      const pattern = /[$\\@\\#%^&*()[\]+_{}`~=|!;:''"",<>.?]/g
      this.keyword = this.keyword.replace(pattern, '')
      this.keyword = this.keyword.replace(regexForEmoticaon, '')
    },
    search () {
      // 두글자이상 검색
      if (this.keyword.length < 2 && this.searchType == 1) {
        this.singleBtnMsgType = MSG_SEARCH_KEYWORD_LENGTH_LESS
        this.showSingleBtnDialogFlag = true
      } else { // 진입 경로에 따라 다른 검색api 적용
        this.searchType ? this.storeSearchList(false) : this.requestSearchMenu()
        this.hasSearched = true
      }
    },
    async storeSearchList (loadMoreCheck) { // 매장검색
      const req = {
        keyword: this.keyword,
        curPage: loadMoreCheck ? ++this.page : this.page
      }
      const { data } = await service.foodClassSearch(req)
      if (data.resultCode == 0) {
        this.menuName = this.keyword !== '' ? this.keyword : '전체'
        this.loadMoreAdd(data, loadMoreCheck)
      }
    },
    loadMoreAdd (data, loadMoreCheck) {
      this.isLastPage = data.store.isLastPage
      if (!loadMoreCheck) {
        this.list = data.store.list
        sessionStorage.getItem('langType')
          ? this.$i18n.locale = sessionStorage.getItem('langType')
          : this.$i18n.locale = this.$store.getters.langType
      } else {
        this.list.push(...data.store.list)
        $state.loaded()
      }
    },
    requestSearchMenu () { // 상품검색
      // 특수문자 및 이모티콘 방지
      if (!this.checkInputData(this.keyword, (newKeyword) => { this.keyword = newKeyword })) {
        this.toast(this, DIS_ACCEPT_INPUT_DATA)
      } else {
        // 상품 검색 API 요청은 이곳에서 수행
        this.$store.dispatch(REQ_MENU_SEARCH, this.keyword)
          .then((response) => {
            this.menus = response.menuList
            this.menuName = this.keyword !== '' ? this.keyword : '전체'
          })
          .catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
      }
    },
    async reqQr (code, menuExistFlag) { // 매장 QR URL 요청
      const res = await service.storeIntroUrl({ urlCode: code })
      if (menuExistFlag == 0) {
        this.singleBtnMsgType = 15
        this.showSingleBtnDialogFlag = true
      } else if (res.data.resultCode == 0) {
        let baseUrl = res.data.introUrl
        const currentURL = window.location.href
        if (currentURL.indexOf('localhost') !== -1) {
          baseUrl = 'http://localhost:8003/menu/modn/mobile/ui/main?token=eyJ0b2tlbiI6ImQzMmU2NTlmLWQ3MGItNDM2Yy05YmNhLTNlNGE0ZmY5YzExYiIsIm9yZGVyU2VxIjoiMjMxMjAxMDA1MDYwNjIiLCJzdG9yZUNvZGUiOjI2MjYsInN0b3JlTmFtZSI6IuuqqOuToCDrtoTsi50iLCJvcmRlclRva2VuIjoiNDE0Mzc1MjEzYjEwNDUzNTA4MzU0MTljOWMxZmNmMTYxOTI1MmNiYzU4N2ViZDMzY2EiLCJ0YWJsZU5vIjotMSwiY2FyZENvZGUiOiIwMDAiLCJjcmVkaXQiOnRydWUsInFyVHlwZSI6MSwiYWxpdmUiOmZhbHNlfQ%3D%3D'
        }
        sessionStorage.removeItem('tradition')
        sessionStorage.removeItem('categoryCode')
        sessionStorage.removeItem('addressByLotNum')
        sessionStorage.removeItem('time')
        window.location.replace(baseUrl)// 가맹점 QR URL 리다이렉트하기
      } else {
        this.toast(this, res.data.resultMsg)
      }
    },
    onClickConfirmBtn () {
      this.showSingleBtnDialogFlag = false
    }
  }
})
</script>
<style scoped>
.zone-left img{height: 64px; width: 64px;}

.zone-right {
  margin-top: 0;
  .name {
    margin-bottom: 6px;
  }
  .package,
  .no-delivery,
  .freeTag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    height: 20px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
  }
  .package {
    background-color: #ffe4dc;
    color: var(--primary);
  }
  .no-delivery {
    background-color: #ececf2;
    color: #0d0d0d;
  }
  .info-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 4px;
    row-gap: 8px;
    .sp1,
    .sp2,
    .distance,
    .freeTag {
      margin-right: 0;
    }
  }
}
</style>
